export default "__VITE_ASSET__C1wlJX2t__"